var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOilDrill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 58 58",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "006---Oil-Drilling",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m8 48c-.55228475 0-1-.4477153-1-1v-14.01c0-.5522847.44771525-1 1-1s1 .4477153 1 1v14.01c0 .5522847-.44771525 1-1 1z",
    fill: "#547580"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m23.44 26.73-.38.16-14.14 5.95c-1.0465796.5025791-2.30242085.0615796-2.80499997-.985s-.06157961-2.3024209.98499997-2.805l13.92-7.57 12.72-6.92 6.79-3.69 3.46 7.21-6.99 2.94z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "m25.06 29h7.87v8h-7.87z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#95a5a5",
    height: 6,
    rx: 1,
    width: 58,
    y: 52
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m18.29 52 10.39-23.01-5.46-2.46-11.51 25.47z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m46.29 52-11.51-25.47-5.46 2.46 10.38 23.01z",
    fill: "#f29c1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m20.55 47h16.89l-2.25-5h-12.38z",
    fill: "#e57e25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m54 40.07c0 2.209139-1.790861 4-4 4s-4-1.790861-4-4c.0321818-.4956101.1471033-.9823365.34-1.44.7853482-1.8870279 1.7996164-3.6703934 3.02-5.31.1510835-.2014447.3881942-.32.64-.32s.4889165.1185553.64.32c1.2203836 1.6396066 2.2346518 3.4229721 3.02 5.31.1928967.4576635.3078182.9443899.34 1.44z",
    fill: "#2c3e50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m53.66 38.63c-.6465336 1.442091-2.0796101 2.3701097-3.66 2.3701097s-3.0134664-.9280187-3.66-2.3701097c.7853482-1.8870279 1.7996164-3.6703934 3.02-5.31.1510835-.2014447.3881942-.32.64-.32s.4889165.1185553.64.32c1.2203836 1.6396066 2.2346518 3.4229721 3.02 5.31z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m43.98 18.056c1.5622085 3.255773 3.3363525 6.4055383 5.311 9.429.411577.6274114 1.2428695.8218195 1.89.442.3017775-.1763857.5286795-.4569901.638-.789 3.0876239-8.882569 1.2089646-18.73733748-4.93-25.861-.4717859-.54313571-1.2768195-.64398039-1.868-.234l-2.621 1.82c-.2398575.16423968-.4220941.39964323-.521.673-.863102 2.35064262-1.3196268 4.83109442-1.35 7.335",
    fill: "#95a5a5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m32.51 23.91c-.3999072.0000955-.7614172-.2380728-.9191584-.6055554s-.0813777-.7936073.1941584-1.0834446c.1823444-.1943935.434747-.3079509.7011713-.3154611s.5248231.0916483.7178287.2754611c.1927458.1809933.3053498.4313827.3128583.6956802.0075084.2642974-.0906988.5206758-.2728583.7123198l-.01.011c-.1887686.1980181-.4504223.3100521-.724.31z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m27.92 25.85h-.01c-.5513018-.0027565-.9963752-.4511805-.9949969-1.0024875s.4486882-.9975.9999969-.9975.9986186.446193.9999969.9975-.4436951.999731-.9949969 1.0024875z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "m6 47h4c1.1045695 0 2 .8954305 2 2v3h-8v-3c0-1.1045695.8954305-2 2-2z",
    fill: "#7f8c8d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29,
    cy: 21,
    fill: "#f0c419",
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 29,
    cy: 21,
    fill: "#f3d55b",
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOilDrill);
export default __webpack_public_path__ + "static/media/oil-drill.f53f484a2d221a462caafddb322a004e.svg";
export { ForwardRef as ReactComponent };